import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4523026a&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=4523026a&scoped=true&lang=css&"
import style1 from "./Register.vue?vue&type=style&index=1&id=4523026a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523026a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4523026a')) {
      api.createRecord('4523026a', component.options)
    } else {
      api.reload('4523026a', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=4523026a&scoped=true&", function () {
      api.rerender('4523026a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/Register.vue"
export default component.exports